import EDListPageHeader from './EDListPageHeader';
import EDListPageTable from './EDListPageTable';
import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';

import {
  useGetExceptionDeals,
  useGetArchiveExceptionDeals,
  useGetExceptionDealsStats,
} from '../hooks/exceptionDeal';
import { useRoles } from '../../../provider/UserRoleProvider';
import { useSearchParams } from 'react-router-dom';
import { useAlert } from 'src/hooks/useAlert';
import { useAccount } from '@azure/msal-react';
import { GridSortDirection, GridSortModel } from '@mui/x-data-grid';
import { useTranslate } from '@im/react-localization';

export default function EDListPage(props: any) {
  const { isCOGUser } = useRoles();
  const user: string = useAccount()?.username ?? '';
  const [searchParams, setSearchParams] = useSearchParams();
  const showAlert = useAlert();
  const countryCode = searchParams.get('countryCode');
  const paramFilters = searchParams.get('filters');
  const paramVendors = searchParams.get('vendors');
  const paramDateValues = searchParams.get('dateValues');
  const paramDateType = searchParams.get('dateType');
  const sortField = searchParams.get('sortField');
  const sortType = searchParams.get('sortType');
  const translate = useTranslate();
  const page = searchParams.get('page');
  const pageSize = searchParams.get('pageSize');
  const [businessType, setBusinessType] = useState('');
  const [dropdownSearch, setDropdownSearch] = useState<
    | {
        dealNumber?: string;
        enduserName?: string;
        programName?: string;
        resellerName?: string;
        vendorName?: string;
      }
    | undefined
  >(undefined);
  const [dateValues, setDateValues] = useState<
    | {
        maxuploadDate?: string;
        minuploadDate?: string;
        uploadDate?: string;
      }
    | undefined
  >(undefined);
  const [sortModel, setSortModel] = useState<GridSortModel>([
    { field: 'deal_ingested_on', sort: 'desc' },
  ]);
  const [dateType, setDateType] = useState<string>('date');
  const [filters, setFilters] = useState<string>('');
  const [vendors, setVendors] = useState<string>('');
  const [pageSetup, setPageSetup] = useState<{
    page: number;
    pageSize: number;
  }>({ page: 1, pageSize: 10 });
  const [archivepageSetup, setarchivePageSetup] = useState<{
    page: number;
    pageSize: number;
  }>({ page: 1, pageSize: 10 });
  const getFilters = () => {
    if (filters === '' && !dropdownSearch) {
      if (isCOGUser) {
        return '7,9,10,12,14';
      } else {
        return '7,8,9,10,12,14';
      }
    } else {
      return filters;
    }
  };
  const [searchInput, setSearchInput] = useState('');
  const [defaultValue, setDefaultValue] = useState(0);
  const requestBody = {
    businessType: businessType,
    countryCode: String(countryCode),
    filters: getFilters(),
    initialLoad:
      filters === '' && vendors === '' && !dropdownSearch && !dateValues,
    page: pageSetup.page,
    pageSize: pageSetup.pageSize,
    sortingColumn: sortModel[0].field,
    sortingOrder: sortModel[0].sort,
    vendorid: vendors,
    ...dropdownSearch,
    ...dateValues,
  };
  const archiverequestBody = {
    businessType: businessType,
    countryCode: String(countryCode),
    filters: getFilters(),
    initialLoad: filters === '' && !dropdownSearch,
    page: archivepageSetup.page,
    pageSize: archivepageSetup.pageSize,
    sortingColumn: sortModel[0].field,
    sortingOrder: sortModel[0].sort,
    vendorid: vendors,
    ...dropdownSearch,
    ...dateValues,
  };
  const activeDeals = useGetExceptionDeals(requestBody);
  const archiveDeals = useGetArchiveExceptionDeals(archiverequestBody);
  // need to check how we can handle this
  const getStats = useGetExceptionDealsStats(requestBody);
  useEffect(() => {
    if (paramFilters) {
      setFilters(paramFilters);
    }
    if (page) {
      setPageSetup({ ...pageSetup, page: Number(page) });
    }
    if (pageSize) {
      setPageSetup({ ...pageSetup, pageSize: Number(pageSize) });
    }
    if (paramVendors) {
      setVendors(paramVendors);
    }
    if (paramDateValues) {
      setDateValues(JSON.parse(paramDateValues));
    }
    if (paramDateType) {
      setDateType(paramDateType);
    }
    if (sortField && sortType) {
      setSortModel([{ field: sortField, sort: sortType as GridSortDirection }]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (filters === '') {
      searchParams.delete('filters');
    } else {
      searchParams.set('filters', filters);
    }
    setSearchParams(searchParams, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);
  useEffect(() => {
    if (vendors === '') {
      searchParams.delete('vendors');
    } else {
      searchParams.set('vendors', vendors);
    }
    setSearchParams(searchParams, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vendors]);
  useEffect(() => {
    if (!dateValues) {
      searchParams.delete('dateValues');
    } else {
      searchParams.set('dateValues', JSON.stringify(dateValues));
    }
    setSearchParams(searchParams, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateValues]);
  useEffect(() => {
    searchParams.set('dateType', dateType);
    setSearchParams(searchParams, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateType]);
  useEffect(() => {
    searchParams.set('sortField', sortModel[0].field);
    searchParams.set('sortType', sortModel[0].sort ?? '');
    setSearchParams(searchParams, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortModel]);
  useEffect(() => {
    searchParams.set('page', String(pageSetup.page));
    searchParams.set('pageSize', String(pageSetup.pageSize));
    setSearchParams(searchParams, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageSetup]);

  const onTabChange = (_type: string) => {
    setBusinessType(_type);
    setFilters('');
    setPageSetup({ page: 1, pageSize: 10 });
    setDateType('date');
    setVendors('');
    searchParams.delete('searchValue');
    searchParams.delete('dropDownOption');
    setSearchParams(searchParams, { replace: true });
    setSearchInput('');
    setDefaultValue(0);
    setDropdownSearch(undefined);
  };

  return (
    <Box px={3} py={2}>
      {countryCode === null &&
        showAlert({ text: 'Missing country code !!!', type: 'error' })}
      <EDListPageHeader
        businessType={businessType}
        data={getStats.error ? undefined : getStats.data}
        filters={filters}
        isLoading={getStats.isLoading}
        onTabChange={onTabChange}
        role={isCOGUser}
        setFilters={setFilters}
      />
      <EDListPageTable
        businessType={businessType}
        data={activeDeals.data}
        dateType={dateType}
        dateValues={dateValues}
        defaultValue={defaultValue}
        filters={filters}
        isLoading={activeDeals.isLoading}
        pageSetup={pageSetup}
        role={isCOGUser}
        searchInput={searchInput}
        setDateType={setDateType}
        setDateValues={setDateValues}
        setDefaultValue={setDefaultValue}
        setDropdownSearch={setDropdownSearch}
        setFilters={setFilters}
        setPageSetup={setPageSetup}
        setSearchInput={setSearchInput}
        setSortModel={setSortModel}
        setVendors={setVendors}
        sortModel={sortModel}
        user={user}
        vendors={vendors}
      />
      {defaultValue === 0 && searchInput.trim() !== '' && (
        <>
          <Box component="span" sx={{ color: 'primary.main' }}>
            {translate('VendorDeals.Archive')}
          </Box>
          <EDListPageTable
            businessType={businessType}
            data={archiveDeals.data}
            dateType={dateType}
            dateValues={dateValues}
            defaultValue={defaultValue}
            filters={filters}
            hideControls
            isLoading={archiveDeals.isLoading}
            pageSetup={archivepageSetup}
            role={isCOGUser}
            searchInput={searchInput}
            setDateType={setDateType}
            setDateValues={setDateValues}
            setDefaultValue={setDefaultValue}
            setDropdownSearch={setDropdownSearch}
            setFilters={setFilters}
            setPageSetup={setarchivePageSetup}
            setSearchInput={setSearchInput}
            setSortModel={setSortModel}
            setVendors={setVendors}
            sortModel={sortModel}
            user={user}
            vendors={vendors}
          />
        </>
      )}
    </Box>
  );
}
